import { createSwrListStore } from './swr/createSwrListStore';
import { getMyVoices } from '../lib/api';

const swr = createSwrListStore({
  name: 'VoiceLibraryStore',
  storageKey: 'bookthing-voice-library',
  itemsField: 'libraryVoices',
  maxItems: 200,
  setters: {
    set: 'setLibraryVoices',
    add: 'addLibraryVoice',
    update: 'updateLibraryVoice',
    remove: 'removeLibraryVoice',
    reset: 'resetLibraryVoices',
  },
  fetcher: async () => {
    const result = await getMyVoices({ limit: 200 });
    return result.voices || [];
  },
});

export const useVoiceLibraryStore = swr.useStore;
export const useVoiceLibraryData = swr.useData;
export const fetchVoiceLibraryIfStale = swr.fetchIfStale;

